import { IGroupSpaceResource } from "../../group-spaces";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IGroupSpace } from "../types";

export type IGroupSpaceQueryParameters = {
    groupSpace?: RelationalValue<IGroupSpaceResource>;
};

export type IGroupSpaceQueryResult = IGroupSpace;

export const groupSpaceQuery: IApiQueryFunction<IGroupSpaceQueryParameters> = ({ groupSpace }) => {
    if (!groupSpace) {
        return;
    }

    return {
        method: "GET",
        url: `/group_spaces/${mapRelationalValue(groupSpace)}`,
    };
};

export const useGroupSpaceQuery = createApiQueryHook<IGroupSpaceQueryParameters, IGroupSpaceQueryResult, any>(
    groupSpaceQuery,
);
